
import React from 'react';
import { compose, contains } from 'ramda';
import moment from 'moment';
import { Map } from 'immutable';
import styleFile from './header.js';
import { RichText, } from '@synergycms_core/components/generic';
import { withThemeJSS } from '@synergycms_core/components/providers/themeProvider';
import DateInfo from './DateInfo.jsx';
import Icon from '@synergycms_core/components/generic/Icon';
import { HALF_STAR_TYPES } from '../Stars';

const ReservationInfo = compose(withThemeJSS({ styleFile, displayName: 'Header' }))((props) => {
  const { city, country, params, theme, availInfoTheme, stayLength, dateFormat, modalBreak } = props;

  const { classes } = theme.styles;

  const sessionBookingDates = JSON.parse(sessionStorage.getItem('booking_dates') ?? '{}');
  const hasSessionDates = sessionBookingDates.start && sessionBookingDates.end;

  const urlStart = params.get('date') ? moment(params.get('date')) : null;
  const urlEnd = params.get('date') ? moment(params.get('date')).add(params.get('stay_length'), 'days') : null;
  const hasUrlDates = urlStart && urlEnd;

  let dateStart = null;
  let dateEnd = null;

  const today = moment().startOf('day');

  if (hasUrlDates) {
    if (urlStart.isBefore(today) || urlEnd.isBefore(today)) {
      sessionStorage.removeItem('booking_dates');
      dateStart = null;
      dateEnd = null;
    } else {
      dateStart = urlStart;
      dateEnd = urlEnd;

      sessionStorage.setItem(
        'booking_dates',
        JSON.stringify({
          start: urlStart.format('YYYY-MM-DD'),
          end: urlEnd.format('YYYY-MM-DD')
        })
      );
    }
  } else if (hasSessionDates) {
    dateStart = sessionBookingDates.start;
    dateEnd = sessionBookingDates.end;
  }

  const cx = props.theme.bind();

  const destination = (city.size && city) || (country.size && country) || Map();

  const isMono = props.currentStep.get('type') === 'mono';
  const stars = props.hotel.get('stars', '') || '';
  const categoryType = props.hotel.get('category_type', 'default');
  const showHalfStarBadge = isMono && categoryType === 'half_stars' && HALF_STAR_TYPES.includes(stars);
  const destinationFilled = isMono ? props.hotel.get('name', '') : destination.get('name', '');
  const displayText = isMono && stars && stars !== '0*'
    ? destinationFilled + ' ' + (showHalfStarBadge ? stars.substring(0, 1) : stars)
    : destinationFilled;

  const renderMinimalView = () => {
    return (
      <>
        {destinationFilled.trim() !== '' && (
          <div className={[classes.locContainer, classes.minLocationContainer].join(' ')}>
            <RichText
              icon={{ unicodeContent: 'e088', innerStyle: ['size23'] }}
              innerStyle={[classes.headerTitle, classes.destinationIcon]}
            />
            <RichText translate={true} ucFirst={true} innerStyle={classes.supTitle} />
            <div className={classes.hotelNameContainer}>
              <RichText
                text={displayText}
                innerStyle={[classes.headerTitle, classes.hotelName, classes.engineClosedTitles]}
              />
              {showHalfStarBadge && (
                <span className={classes.starBadge}>
                  <Icon config={{ content: '*' }} innerStyle={['mainColor']} />
                  <span className={classes.starBadgeHalf}>
                    <Icon config={{ content: '*' }} innerStyle={['mainColor', classes.starBadgeHalfIcon]} />
                  </span>
                </span>
              )}
            </div>
          </div>
        )}
        <div className={[classes.floatedContainer, classes.minimalDateContainer].join(' ')}>
          <div className={classes.dateContainer}>
            <RichText
              icon={{ unicodeContent: 'e151', innerStyle: ['size23'] }}
              innerStyle={[classes.headerTitle, classes.calendarIcon]}
            />
            <DateInfo dateStart={dateStart} dateEnd={dateEnd} mode={availInfoTheme} dateFormat={dateFormat} modalBreak={modalBreak} />
          </div>
        </div>
      </>
    );
  };

  const renderMinimalMobileView = () => {
    return (
      <div className={classes.floatedContainer}>
        {destinationFilled.trim() !== '' && (
          <div className={[classes.locContainer, classes.mobileLocContainer].join(' ')}>
            <div className={classes.hotelNameContainer}>
              <RichText
                text={destinationFilled}
                innerStyle={[classes.headerTitle, classes.hotelName, classes.engineClosedTitles]}
              />
              {props.currentStep.get('type') === 'mono' &&
                props.hotel.get('stars', '') !== '0*' &&
                !modalBreak && (
                  <RichText
                    text={props.hotel.get('stars', '')}
                    innerStyle={[classes.headerTitleStars, 'uppercase', classes.engineClosedTitles]}
                  />
                )}
            </div>
          </div>
        )}
        <div className={[classes.dateContainer, classes.mobileDateContainer].join(' ')}>
          <RichText
            icon={{
              unicodeContent: 'e151',
              innerStyle: ['size20']
            }}
            innerStyle={classes.supTitle}
          />
          <DateInfo dateStart={dateStart} dateEnd={dateEnd} mode={availInfoTheme} dateFormat={dateFormat} modalBreak={modalBreak}/>
          {!contains(props.currentStep.get('code'), ['noAvail']) && (
            <RichText
              text={'_%{value} noche%_'}
              withVars={{ value: stayLength }}
              innerStyle={classes.nightsTitle}
              plural={stayLength !== 1}
              translate={true}
            />
          )}
        </div>
      </div>
    );
  };

  const renderCompleteView = () => {
    return (
      <div className={classes.floatedContainer}>
        {destinationFilled.trim() !== '' && (
          <div className={classes.locContainer}>
            <RichText
              text={!modalBreak && (props.currentStep.get('type') === 'mono' ? '_%hotel%_' : '_%destino%_')}
              icon={{
                unicodeContent: 'e088',
                innerStyle: [cx({ size22: !modalBreak, size16: modalBreak }), classes.absoluteIcon]
              }}
              translate={true}
              ucFirst={true}
              innerStyle={classes.supTitle}
            />
            <div className={classes.hotelNameContainer}>
              <RichText text={destinationFilled} innerStyle={[classes.headerTitle, classes.engineClosedTitles]} />
              {props.currentStep.get('type') === 'mono' &&
                props.hotel.get('stars', '') !== '0*' &&
                !modalBreak && (
                  <RichText
                    text={props.hotel.get('stars', '')}
                    innerStyle={[classes.headerTitleStars, 'uppercase', classes.engineClosedTitles]}
                  />
                )}
            </div>
          </div>
        )}
        <div className={classes.dateContainer}>
          <RichText
            text={!modalBreak && '_%Fechas%_'}
            icon={{
              svg: 'calendar',
              innerStyle: [classes.absoluteSvg]
            }}
            translate={true}
            ucFirst={true}
            innerStyle={classes.supTitle}
          />
          <DateInfo dateStart={dateStart} dateEnd={dateEnd} mode={availInfoTheme} dateFormat={dateFormat} modalBreak={modalBreak}/>
        </div>
      </div>
    );
  };

  if (availInfoTheme === 'minimal') {
    if (!modalBreak) {
      return renderMinimalView();
    } else {
      return renderMinimalMobileView();
    }
  } else {
    return renderCompleteView();
  }
});


export default ReservationInfo;
